/**
 * OrganizationDetail-new.tsx
 * New-page entry point for Organization Detail redesign.
 * This wrapper reuses the existing OrganizationDetail logic until Figma-specific UI is applied.
 */

import React from 'react';
import OrganizationDetailPage from './OrganizationDetail';

/**
 * OrganizationDetailNew
 * Named page component for the new Organization Detail route.
 */
function OrganizationDetailNew(): React.ReactElement
{
    return <OrganizationDetailPage />;
}

export default OrganizationDetailNew;
